import axios from "axios";

export default function EntrylocationDownloadReportService(entrylocationId) {
  return axios.get(process.env.REACT_APP_API_HOST + "/entry_location/" + entrylocationId + "/report", {
    responseType: 'blob',
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  })
};
